interface CustomTableHeadProps {
  dataList: string[]
  className?: string
  cellClassName?: string
}
const CustomTableHead = ({
  dataList,
  className,
  cellClassName = '',
}: CustomTableHeadProps) => {
  return (
    <thead>
      <tr className={className}>
        {dataList.map((data) => (
          <th scope="col" key={data} className={`text-left ${cellClassName}`}>
            {data}
          </th>
        ))}
      </tr>
    </thead>
  )
}

export default CustomTableHead
